module.exports = __webpack_public_path__ + "static/media/investor-illustration.0b10edb8.png";